<template>
  <Modal
    v-model="visible"
    title="已选工程"
    footer-hide
    :width="80"
  >
    <Table border :columns="columns" :data="selection" :height="clientHeight - 300"></Table>
  </Modal>
</template>

<script>
export default {
  name: 'search-selectionModal',
  props: {
    selection: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      visible: false,
      clientHeight: 0,
      columns: []
    }
  },
  mounted () {
    this.buildColumns()
  },
  methods: {
    open () {
      this.clientHeight = document.body.clientHeight
      this.visible = true
    },
    buildColumns () {
      this.columns = [
        {
          title: '工程名称',
          key: 'PROJECTNAME'
        }, {
          title: '操作',
          align: 'center',
          width: 90,
          render: (h ,{ row }) => {
            return (
              <Button type="info" size="small" onClick={ () => { this.handleCancelApply(row) } }>取消</Button>
            )
          }
        }
      ]
    },
    handleCancelApply (row) {
      this.$emit('on-cancel-apply', row)
      !this.selection.length && (this.visible = false)
    }
  }
}
</script>
